import styled, { createGlobalStyle } from 'styled-components';

export const CuratorOfferSaveConfirmGlobalStyle = createGlobalStyle`
  .curator-offer-confirm-wrap {
    display: flex !important;
    align-items: center;
    justify-content: center;

    .ant-modal {
      top: 0 !important;
      padding-bottom: 0 !important;
      margin: 0 auto;
    }
  }

  .curator-offer-save-modal {
    .ant-modal-confirm-title {
      display: none;
    }

    .ant-modal-confirm-body > .anticon {
      display: none;
    }

    .ant-modal-confirm-content {
      margin-left: 0 !important;
      margin-top: 0 !important;
    }

    .ant-modal-confirm-btns {
      margin-top: 20px;
    }

    .ant-btn-primary {
      background: #3ecf8e;
      border-color: #3ecf8e;
      color: #0b0f1b;
      font-weight: 600;

      &:hover,
      &:focus {
        background: #35b87d;
        border-color: #35b87d;
        color: #0b0f1b;
      }
    }
  }

  .curator-offer-save-modal__message {
    margin: 0 0 0;
    font-size: 15px;
    line-height: 1.55;
    color: #f6f8fb;
    font-weight: 500;

    strong {
      color: #3ecf8e;
      font-weight: 600;
    }
  }

  .curator-offer-save-modal__note {
    margin: 14px 0 0;
    padding-top: 14px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    font-size: 13px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.55);
  }

  .curator-offer-save-modal__note-label {
    color: rgba(255, 255, 255, 0.75);
    font-weight: 500;
  }
`;

export const CuratorOffersPageStyle = styled.div`
  min-height: calc(100vh - 64px);
  background: #0b0f1b;
  color: #f6f8fb;
  display: flex;
  flex-direction: column;
  padding-bottom: 140px;

  .curator-offers-header {
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    padding: 40px 24px 28px;
    text-align: center;

    .header-inner {
      max-width: 1280px;
      margin: 0 auto;
    }

    h1 {
      margin: 0 0 12px;
      font-size: 42px;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
      font-family: 'Poppins', sans-serif;
      background: linear-gradient(135deg, #ffffff 0%, #e0e0e0 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      letter-spacing: -0.02em;

      @media (max-width: 768px) {
        font-size: 28px;
      }
    }

    .beta-badge {
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0.04em;
      text-transform: uppercase;
      background: rgba(59, 130, 246, 0.2);
      color: #93c5fd;
      border: 1px solid rgba(59, 130, 246, 0.35);
      border-radius: 999px;
      padding: 4px 10px;
      -webkit-text-fill-color: #93c5fd;
    }

    p {
      margin: 0 auto;
      color: rgba(255, 255, 255, 0.65);
      max-width: 680px;
      line-height: 1.55;
      font-size: 16px;
    }

    .header-links {
      margin-top: 16px;
      display: flex;
      justify-content: center;
      gap: 16px;
      flex-wrap: wrap;

      a {
        color: #93c5fd;
        font-size: 14px;
        font-weight: 500;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .curator-offers-body {
    flex: 1;
    max-width: 1280px;
    width: 100%;
    margin: 0 auto;
    padding: 24px;
    display: grid;
    grid-template-columns: 320px minmax(0, 1fr);
    gap: 24px;
    align-items: start;

    @media (max-width: 960px) {
      grid-template-columns: 1fr;
    }
  }

  .offer-library-sidebar {
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.05) 100%);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 16px;
    padding: 18px;
    height: fit-content;
    position: sticky;
    top: 24px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);

    &__header h2 {
      margin: 0 0 4px;
      font-size: 18px;
      font-weight: 600;
      color: #fff;
    }

    &__header p {
      margin: 0 0 16px;
      font-size: 13px;
      color: rgba(255, 255, 255, 0.55);
      line-height: 1.4;
    }

    &__stats {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 8px;
      margin-bottom: 14px;
    }

    &__stat {
      min-width: 0;
      padding: 8px 6px;
      border-radius: 10px;
      background: rgba(255, 255, 255, 0.04);
      border: 1px solid rgba(255, 255, 255, 0.06);
      text-align: center;

      strong {
        display: block;
        font-size: 18px;
        font-weight: 700;
        color: #fff;
      }

      span {
        display: block;
        font-size: 10px;
        color: rgba(255, 255, 255, 0.5);
        letter-spacing: 0.02em;
        white-space: nowrap;
      }
    }

    &__list {
      display: flex;
      flex-direction: column;
      gap: 8px;
      margin-bottom: 12px;
      max-height: 420px;
      overflow-y: auto;
    }

    &__new {
      width: 100%;
      border: 1px dashed rgba(255, 255, 255, 0.2);
      background: transparent;
      color: #93c5fd;
      border-radius: 10px;
      padding: 10px 12px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      font-weight: 600;
      transition: all 0.2s ease;

      &:hover {
        background: rgba(59, 130, 246, 0.08);
        border-color: rgba(59, 130, 246, 0.35);
      }
    }

    &__hint {
      margin-top: 12px;
      font-size: 12px;
      color: #fbbf24;
      line-height: 1.4;
      padding: 8px 10px;
      border-radius: 8px;
      background: rgba(251, 191, 36, 0.08);
      border: 1px solid rgba(251, 191, 36, 0.2);
    }
  }

  .offer-library-card {
    text-align: left;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(255, 255, 255, 0.02);
    border-radius: 12px;
    padding: 12px;
    cursor: pointer;
    color: inherit;
    transition: all 0.2s ease;

    &:hover {
      border-color: rgba(255, 255, 255, 0.15);
      background: rgba(255, 255, 255, 0.04);
    }

    &.is-active {
      border-color: rgba(59, 130, 246, 0.55);
      background: rgba(59, 130, 246, 0.12);
      box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.2);
    }

    &__top {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 8px;
      margin-bottom: 4px;
    }

    &__label {
      display: block;
      font-weight: 600;
      font-size: 14px;
    }

    &__badge {
      font-size: 10px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.04em;
      padding: 2px 8px;
      border-radius: 999px;
      flex-shrink: 0;

      &.is-complete {
        background: rgba(34, 197, 94, 0.15);
        color: #86efac;
        border: 1px solid rgba(34, 197, 94, 0.3);
      }

      &.is-draft {
        background: rgba(251, 191, 36, 0.12);
        color: #fcd34d;
        border: 1px solid rgba(251, 191, 36, 0.25);
      }
    }

    &__meta,
    &__genres {
      display: block;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.55);
    }
  }

  .offer-editor {
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.05) 100%);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 16px;
    padding: 0;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
    overflow: hidden;

    &__toolbar {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      align-items: center;
      justify-content: space-between;
      padding: 20px 20px 16px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.08);
      background: rgba(255, 255, 255, 0.02);
    }

    &__label-field {
      flex: 1;
      min-width: 220px;
      max-width: 420px;

      label {
        display: block;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.55);
        margin-bottom: 4px;
      }
    }

    &__label-input {
      width: 100%;
      border-radius: 10px !important;
      background: rgba(255, 255, 255, 0.06) !important;
      border-color: rgba(255, 255, 255, 0.12) !important;
      color: #fff !important;
    }

    &__actions {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
    }

    &__validation-banner {
      margin: 0 20px 16px;
      padding: 12px 14px;
      border-radius: 10px;
      background: rgba(239, 68, 68, 0.1);
      border: 1px solid rgba(239, 68, 68, 0.3);
      color: #fca5a5;
      font-size: 13px;
      line-height: 1.45;

      strong {
        color: #fecaca;
      }

      ul {
        margin: 6px 0 0;
        padding-left: 18px;
      }
    }

    &__steps {
      display: flex;
      gap: 0;
      padding: 0 20px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.08);
      background: rgba(0, 0, 0, 0.15);
    }

    &__step {
      flex: 1;
      padding: 14px 16px;
      font-size: 13px;
      font-weight: 600;
      color: rgba(255, 255, 255, 0.45);
      border-bottom: 2px solid transparent;
      display: flex;
      align-items: center;
      gap: 8px;

      &.is-active {
        color: #93c5fd;
        border-bottom-color: #3b82f6;
        background: rgba(59, 130, 246, 0.06);
      }

      .step-number {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
        background: rgba(255, 255, 255, 0.08);
      }

      &.is-active .step-number {
        background: rgba(59, 130, 246, 0.25);
        color: #93c5fd;
      }
    }

    &__content {
      padding: 20px;
    }

    &__note {
      margin: 0 0 16px;
      padding: 10px 12px;
      border-radius: 10px;
      background: rgba(59, 130, 246, 0.1);
      border: 1px solid rgba(59, 130, 246, 0.25);
      color: rgba(255, 255, 255, 0.75);
      font-size: 13px;
      line-height: 1.45;
    }

    &__sections {
      display: grid;
      gap: 24px;
    }

    &__section {
      padding: 16px;
      border-radius: 14px;
      border: 1px solid rgba(255, 255, 255, 0.08);
      background: rgba(0, 0, 0, 0.15);
    }

    &__section-title {
      margin: 0 0 12px;
      font-size: 16px;
      font-weight: 600;
      display: flex;
      align-items: center;
      gap: 8px;
      color: #f6f8fb;

      .step-number {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
        background: rgba(59, 130, 246, 0.25);
        color: #93c5fd;
      }
    }

    &__footer {
      padding: 16px 20px;
      border-top: 1px solid rgba(255, 255, 255, 0.08);
      background: rgba(11, 15, 27, 0.98);
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      flex-wrap: wrap;
    }

    &__footer-status {
      font-size: 13px;
      color: rgba(255, 255, 255, 0.55);

      &.is-ready {
        color: #86efac;
      }

      &.is-incomplete {
        color: #fcd34d;
      }
    }
  }

  .offer-profile-row__other-offer {
    color: #fbbf24 !important;
  }

  .offer-details-fields,
  .offer-profiles-step {
    .form-section {
      margin-bottom: 16px;
    }

    .form-field label,
    .section-title {
      color: #dfe6f3;
      font-size: 13px;
      font-weight: 600;
    }

    .streams-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;

      @media (max-width: 520px) {
        grid-template-columns: 1fr;
      }
    }

    .error-message {
      color: #f87171;
      font-size: 12px;
      margin-top: 4px;
    }

    .required {
      color: #f87171;
    }
  }

  .offer-profiles-step {
    .offer-step-layout {
      display: grid;
      grid-template-columns: minmax(0, 0.95fr) minmax(0, 1.05fr);
      gap: 14px;
      min-height: 360px;

      @media (max-width: 720px) {
        grid-template-columns: 1fr;
        min-height: auto;
      }
    }

    .offer-step-panel {
      display: flex;
      flex-direction: column;
      gap: 10px;
      min-height: 0;
      padding: 12px;
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 14px;
      background: #151b26;
    }

    .offer-step-panel__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;

      h3 {
        margin: 0;
        font-size: 13px;
        font-weight: 600;
        color: #f6f8fb;
      }
    }

    .offer-step-panel__count {
      font-size: 11px;
      color: rgba(255, 255, 255, 0.5);
    }

    .offer-step-search {
      width: 100%;
      height: 36px;
      padding: 0 12px;
      border-radius: 10px;
      border: 1px solid rgba(255, 255, 255, 0.15);
      background: #1f2733;
      color: #fff;
      outline: none;

      &:focus {
        border-color: rgba(59, 130, 246, 0.5);
      }
    }

    .offer-profile-list,
    .offer-playlist-list {
      display: flex;
      flex-direction: column;
      gap: 6px;
      overflow: auto;
      max-height: 280px;
    }

    .offer-profile-row,
    .offer-playlist-row {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 10px;
      border-radius: 10px;
      border: 1px solid transparent;
      background: #111823;
    }

    .offer-profile-row.is-focused {
      border-color: rgba(59, 130, 246, 0.4);
    }

    .offer-profile-row__body {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 2px;
      padding: 0;
      border: 0;
      background: transparent;
      color: inherit;
      text-align: left;
      cursor: pointer;
    }

    .offer-profile-row__name,
    .offer-playlist-row__name {
      font-size: 13px;
      font-weight: 600;
      color: #e9edf5;
    }

    .offer-profile-row__meta {
      font-size: 11px;
      color: rgba(255, 255, 255, 0.5);
    }

    .offer-playlist-row {
      cursor: pointer;
    }

    .offer-playlist-row.is-selected {
      border-color: rgba(59, 130, 246, 0.35);
      background: #102033;
    }

    .offer-playlist-toolbar {
      display: flex;
      gap: 10px;
    }

    .offer-playlist-toolbar__action {
      border: 0;
      background: transparent;
      color: #93c5fd;
      font-size: 12px;
      cursor: pointer;
    }

    .offer-step-empty,
    .offer-step-empty--panel,
    .offer-step-loading {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.55);
      padding: 8px;
    }

    .offer-selection-summary {
      font-size: 12px;
      color: #93c5fd;
      font-weight: 600;
    }
  }

  .curator-offers-empty,
  .curator-offers-loading {
    max-width: 560px;
    margin: 48px auto;
    text-align: center;
    color: rgba(255, 255, 255, 0.7);
    padding: 24px;
  }

  .primary-button,
  .secondary-button,
  .danger-button {
    border-radius: 10px;
    padding: 8px 16px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    font-size: 14px;
    transition: all 0.2s ease;
  }

  .primary-button {
    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
    color: #fff;
    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);

    &:hover:not(:disabled) {
      transform: translateY(-1px);
      box-shadow: 0 6px 16px rgba(37, 99, 235, 0.4);
    }
  }

  .secondary-button {
    background: rgba(255, 255, 255, 0.08);
    color: #fff;
    border: 1px solid rgba(255, 255, 255, 0.12);
  }

  .danger-button {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: rgba(239, 68, 68, 0.15);
    color: #fca5a5;
    border: 1px solid rgba(239, 68, 68, 0.35);
  }

  .primary-button:disabled,
  .secondary-button:disabled,
  .danger-button:disabled {
    opacity: 0.55;
    cursor: not-allowed;
    transform: none;
  }

  /* Ant Design dark theme — consistent 10px rounded inputs */
  .ant-input-number,
  .ant-input-number-group-wrapper,
  .ant-input,
  .ant-input-affix-wrapper,
  .ant-input-textarea,
  .ant-input-textarea textarea {
    border-radius: 10px !important;
    color: #f6f8fb !important;
    background: #1f2733 !important;
    border-color: rgba(255, 255, 255, 0.15) !important;
  }

  .ant-input-number {
    overflow: hidden;
    width: 100%;
  }

  .ant-input-number-input-wrap {
    background: #1f2733 !important;
  }

  .ant-input-number-handler-wrap {
    background: #151b26 !important;
    border-color: rgba(255, 255, 255, 0.15) !important;
    border-radius: 0 10px 10px 0 !important;

    .ant-input-number-handler {
      border-color: rgba(255, 255, 255, 0.1) !important;

      svg {
        fill: #9aa3b5;
      }
    }
  }

  .ant-input-number-input,
  .ant-input-number-input input,
  .ant-input-affix-wrapper input {
    color: #f6f8fb !important;
    background: transparent !important;
    border-radius: 0 !important;
  }

  .ant-input-textarea textarea.ant-input {
    border-radius: 10px !important;
  }

  .ant-input-number-input::placeholder,
  .ant-input::placeholder,
  .ant-input-textarea textarea::placeholder {
    color: #8b94a8 !important;
  }

  .ant-input-number-group-wrapper {
    overflow: hidden;
    width: 100%;
  }

  .ant-input-number-group-addon {
    background: #151b26 !important;
    border-color: rgba(255, 255, 255, 0.15) !important;
    color: #dfe6f3 !important;
  }

  .ant-input-number-group-addon:first-child {
    border-radius: 10px 0 0 10px !important;
  }

  .ant-input-number-group-addon:last-child {
    border-radius: 0 10px 10px 0 !important;
  }

  .ant-input-number-group > .ant-input-number {
    border-radius: 0 !important;
  }

  .ant-input-number-group > .ant-input-number:first-child:last-child {
    border-radius: 10px !important;
  }

  .ant-input-number-group-addon:first-child + .ant-input-number:last-child {
    border-radius: 0 10px 10px 0 !important;
  }

  .offer-editor__label-input.ant-input {
    border-radius: 10px !important;
  }

  .ant-input-number-status-error,
  .ant-input-number-group-wrapper-status-error .ant-input-number-group-addon,
  .ant-input-status-error,
  .ant-input-affix-wrapper-status-error,
  .ant-input-textarea-status-error {
    border-color: #ff6b6b !important;
  }

  .ant-radio-wrapper {
    color: #dfe6f3 !important;

    .ant-radio + span {
      color: #dfe6f3 !important;
    }
  }

  .ant-checkbox-wrapper {
    color: #dfe6f3 !important;

    .ant-checkbox + span {
      color: #dfe6f3 !important;
    }
  }

  .ant-spin {
    color: #93c5fd;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #2563eb;
    border-color: #2563eb;
  }
`;
